var YouLi = YouLi ? YouLi : {};
YouLi.PaymentChargeForm = YouLi.PaymentChargeForm ? YouLi.PaymentChargeForm : {};

(function (YouLi) {
    (function (PaymentChargeForm) {

        YouLi.PaymentChargeForm = {
            Ach: {
                SurchargePercent: 0,
                HasSurcharge: false
            },
            Default: {
                SurchargePercent: 0
            }
        };

        let _paymentChargeForm = {
            Default: {
                surchargeAmount: 0,
                refundProtectAmount: 0,
                refundProtectPercent: 0
            }
        };

        YouLi.PaymentChargeForm.AmountDue = 0;
        YouLi.PaymentChargeForm.BookingAddOnAmountDue = 0;
        YouLi.PaymentChargeForm.Currency = "";
        YouLi.PaymentChargeForm.IsLastPaymentAdaptive = false;

        YouLi.PaymentChargeForm.GetStripeChargeAmount = function (stripePaymentType) {
            const totalAmount = YouLi.PaymentChargeForm.AmountDue
                + YouLi.PaymentChargeForm.GetSurchargeAmount(stripePaymentType)
                + YouLi.PaymentChargeForm.BookingAddOnAmountDue;

            const computed = totalAmount + YouLi.PaymentChargeForm.GetRefundProtectAmount(stripePaymentType);
            return parseFloat(computed.toFixed(2));
        }

        //this is used for payment method selection NOT in stripe UI
        YouLi.PaymentChargeForm.GetChargeAmount = function () {
            let computed = YouLi.PaymentChargeForm.GetChargeAmountNoSurcharge() + _paymentChargeForm.Default.surchargeAmount;
            return parseFloat(computed.toFixed(2));
        }

        YouLi.PaymentChargeForm.GetChargeAmountNoSurcharge = function () {
            return YouLi.PaymentChargeForm.AmountDue
                + _paymentChargeForm.Default.refundProtectAmount
                + YouLi.PaymentChargeForm.BookingAddOnAmountDue;
        }

        YouLi.PaymentChargeForm.GetSurchargeAmount = function (stripePaymentType) {
            let computed = (YouLi.PaymentChargeForm.AmountDue + YouLi.PaymentChargeForm.BookingAddOnAmountDue);
            const surcharge = YouLi.PaymentChargeForm.GetSurchargePercent(stripePaymentType);

            return parseFloat((computed * surcharge / 100).toFixed(2));
        }

        YouLi.PaymentChargeForm.GetRefundProtectAmount = function (stripePaymentType) {
            const totalAmount = YouLi.PaymentChargeForm.AmountDue
                + YouLi.PaymentChargeForm.GetSurchargeAmount(stripePaymentType)
                + YouLi.PaymentChargeForm.BookingAddOnAmountDue;

            return (totalAmount * _paymentChargeForm.Default.refundProtectPercent / 100);
        }

        YouLi.PaymentChargeForm.GetSurchargePercent = function (stripePaymentType) {
            switch (stripePaymentType) {
                case 'us_bank_account':
                    return YouLi.PaymentChargeForm.Ach.SurchargePercent === 0
                        ? YouLi.PaymentChargeForm.Default.SurchargePercent
                        : YouLi.PaymentChargeForm.Ach.SurchargePercent;
                default:
                    return YouLi.PaymentChargeForm.Default.SurchargePercent;
            }
        }

        YouLi.PaymentChargeForm.GetFormattedCurrency = function (amount) {
            return YouLi.Common.Currency.DisplayCost(YouLi.PaymentChargeForm.Currency, amount);
        }

        YouLi.PaymentChargeForm.UpdatePaymentInfo = function (info) {
            if (typeof info !== 'object' || info === null) {
                throw new Error('The argument must be an object.');
            }

            _paymentChargeForm.Default = $.extend({}, _paymentChargeForm.Default, info);
        }

    }(YouLi.PaymentChargeForm ? YouLi.PaymentChargeForm : {}));
}(YouLi ? YouLi : {}));